export function propertyFromApi(apiProperty) {
  return {
    id: apiProperty.id,
    activeDealCount: apiProperty.active_deal_count,
    activeEdgeProjectCount: apiProperty.active_edge_project_count,
    activeListings: apiProperty.active_listings,
    address: apiProperty.address,
    buildingClass: apiProperty.building_class,
    buyer: apiProperty.buyer,
    createdAt: apiProperty.created_at,
    createdBy: apiProperty.created_by,
    city: apiProperty.city,
    county: apiProperty.county,
    customFieldValues: apiProperty.custom_field_values,
    displayName: apiProperty.display_name,
    mergeUrl: apiProperty.merge_url,
    hasThumbnail: apiProperty.has_thumbnail,
    highlights: apiProperty.highlights,
    investmentType: apiProperty.investment_type,
    lastUpdatedAt: apiProperty.last_updated_at,
    lastUpdatedBy: apiProperty.last_updated_by,
    latitude: apiProperty.latitude,
    leaseSuiteNumber: apiProperty.lease_suite_number,
    leaseSize: apiProperty.lease_size,
    leaseCommencement: apiProperty.lease_commencement,
    leaseExecutionDate: apiProperty.lease_execution_date,
    leaseExpiration: apiProperty.lease_expiration,
    leaseRate: apiProperty.lease_rate,
    leaseSpaceType: apiProperty.lease_space_type,
    loanAmount: apiProperty.loan_amount,
    longitude: apiProperty.longitude,
    lotSize: apiProperty.lot_size,
    name: apiProperty.display_name,
    numberOfUnits: apiProperty.number_of_units,
    ownerName: apiProperty.owner_name,
    ownerEmail: apiProperty.owner_email,
    ownerPhone: apiProperty.owner_phone_number,
    ownerPhoneNormalized: apiProperty.owner_phone_normalized,
    ownerUrl: apiProperty.owner_url,
    projectDealStatus: apiProperty.project_deal_status,
    projectCapRate: apiProperty.project_cap_rate,
    projectNoi: apiProperty.project_noi,
    projectSalePrice: apiProperty.project_sale_price,
    projectSalePricePerUnit: apiProperty.project_sale_price_per_unit,
    propertyType: apiProperty.property_type_labels,
    propertySubtype: apiProperty.property_subtype_label,
    searchResults: apiProperty.search_results,
    salePrice: apiProperty.sale_price,
    saleDate: apiProperty.sale_date,
    saleCapRate: apiProperty.sale_cap_rate,
    saleNOI: apiProperty.sale_net_operating_income,
    salePricePerUnit: apiProperty.sale_price_per_unit,
    seller: apiProperty.seller,
    showPath: apiProperty.url,
    size: apiProperty.building_size_label,
    state: apiProperty.state,
    summary: apiProperty.address_one_line,
    databaseName: apiProperty.database_name,
    tenant: apiProperty.tenant,
    thumbnailUrl: apiProperty.thumbnail_url,
    type: apiProperty.deal_status_label,
    yearBuilt: apiProperty.year_built,
    yearRenovated: apiProperty.renovated,
    zip: apiProperty.zip
  };
}
